





























































import { PropType } from 'vue';
import { mapActions } from 'vuex';

import { IContract } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import { setErrorFromAxiosError } from '@/utils/helpers';

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';
import snackbar from '@/mixins/snackbar';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

export default mixins(auth, snackbar).extend({
  name: 'ContractStartRenewalStateButton',

  components: {
    ConfirmationDialog
  },

  props: {
    contract: {
      type: Object as PropType<IContract>
    }
  },

  data() {
    return {
      error: null as ISystemError | null,

      isStateTransitioning: false,
      isDialogActive: false
    };
  },

  methods: {
    ...mapActions({
      initiateContractRenewal: 'contract/initiateContractRenewal'
    }),

    clearErrors() {
      this.error = null;
    },

    closeDialog() {
      this.isDialogActive = false;
    },

    startContractRenewalProcess() {
      this.clearErrors();
      this.isStateTransitioning = true;
      this.initiateContractRenewal(this.contract.id)
        .then(() => {
          this.closeDialog();
          this.createSnack({
            color: 'success darken-1',
            type: 'info',
            right: true,
            msg: 'Started contract renewal process',
            timeout: 4000
          });
        })
        .catch(error => {
          this.error = setErrorFromAxiosError(error);
        })
        .finally(() => {
          this.isStateTransitioning = false;
        });
    }
  }
});
